import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './css/CarAlert.css';
import {getMainCookie} from '../../../../util/util';
import $ from 'jquery';
import { AlertCommit} from '../../../Modals/AlertBar';


let alertConfig="";
let token
class CarAlertList extends Component {
    constructor(props) {
		super(props);
		this.state = {
            alertValueList : [
                    {
                        "alert_type_id": "S1",
                        "is_alert_type": false
                    },
                    {
                        "alert_type_id": "S2",
                        "is_alert_type": false
                    },
                    {
                        "alert_type_id": "O2",
                        "is_alert_type": false
                    },
                    {
                        "alert_type_id": "S3",
                        "is_alert_type": false
                    },
                    {
                        "alert_type_id": "S4",
                        "is_alert_type": false
                    },
                    {
                        "alert_type_id": "O1",
                        "is_alert_type": false
                    },
                    {
                        "alert_type_id": "E2",
                        "is_alert_type": false
                    },
                    {
                        "alert_type_id": "E3",
                        "is_alert_type": false
                    },
                    {
                        "alert_type_id": "E4",
                        "is_alert_type": false
                    },
                    {
                        "alert_type_id": "E6",
                        "is_alert_type": false
                    },
                    {
                        "alert_type_id": "E7",
                        "is_alert_type": false
                    },
                    {
                        "alert_type_id": "E5",
                        "is_alert_type": false
                    },
                    {
                        "alert_type_id": "E1",
                        "is_alert_type": false
                    },
                    {
                        "alert_type_id": "O3",
                        "is_alert_type": false
                    },
                    {
                        "alert_type_id": "O4",
                        "is_alert_type": false
                    }
            ]
        };
    }
    componentDidMount(){
        alertConfig = getMainCookie();
        token = alertConfig.token;
    }
    componentDidUpdate(){
       
    }
    
    handleSave(){
        this.state.alertValueList.map(alerValue=>{
            alerValue.is_alert_type = $("#alert"+alerValue.alert_type_id).prop( "checked");
        });
        let thisCurr = this;
        fetch("http://203.150.199.244/api/admin/setDeviceAlert", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token":token
                },
            body: JSON.stringify(
            
                thisCurr.state.alertValueList
            )
        }).then(res => res.json())
        .then(
            (data) => {
            
            if(data.RESULT_STATUS == "000")
                AlertCommit(true,"บันทึกข้อมูลเรียบร้อยแล้ว");
            else{
                AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
            }
            },
            (error) => {

            }
        );
    }
    setChk(){
        this.clearChkAll();
        let thisCurr = this;
        fetch("http://203.150.199.244/api/admin/getDeviceAlertList", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token":token
                },
            body: JSON.stringify({})
        }).then(res => res.json())
        .then(
            (data) => {
                if(data.RESULT_STATUS == "000"){
                    if( data.RESULT_DATA[0].alerts){
                        data.RESULT_DATA[0].alerts.map(alert =>{
                            if(alert.is_alert_type)
                                $("#alert"+alert.alert_type_id).prop('checked',true );
                        })
                    }
                }
            },
            (error) => {
                console.log(error);
            }
        );
       
    }
    handleChkAll(){
        if ($('#chkAll').is(":checked"))
            $('.car-alert-list input:checkbox').prop('checked',true );
        else
            this.clearChkAll();
    }
    clearChkAll(){
        $('.car-alert-list input:checkbox').prop('checked', false);
    }
    handleCarAlertSelect(index,lat,long,text,symbolId,symbolColor){
        $(".carAlertRow").removeClass("table-warning");
        $("#carAlertRow"+index).addClass("table-warning");
        this.props.onSelect(index,lat,long,text,symbolId,symbolColor);
    }

    render() {
        //console.log("data mount",this.props.carAlertList,this.props.carAlertList.alert);
        let rows = [];
        if(this.props.carAlertList && this.props.carAlertList.alert){
            this.props.carAlertList.alert.map((carAlert,index)=>{
                
                rows.push(<tr style={{height:25}} key={index} id={"carAlertRow"+index} className="carAlertRow" 
                onClick={this.handleCarAlertSelect.bind(this,index,carAlert.latitude,carAlert.longitude
                ,carAlert.device_no+" "+carAlert.alert_type,carAlert.symbol_id,carAlert.symbol_color)}>
                    <td >{index+1}</td>
                    <td >{carAlert.device_no}</td>
                    <td >{carAlert.alert_type}</td>
                    <td style={{textAlign:"center"}}>{carAlert.date}</td>
                    <td style={{textAlign:"center"}}>{carAlert.time}</td>
                </tr>)
            })     
        }
       
        return (
            <div className="car-alert-list">
                
                <div className="row table-responsive" style={{backgroundColor:"#fff",maxHeight:500,overflowY:"auto"}}>
                <table class="table table-hover table-striped ">
                <thead>
                <tr style={{textAlign:"center"}}>
                    <th >#</th>
                    <th >ทะเบียน</th>
                    <th >สถานะ</th>
                    <th >วันที่</th>
                    <th >เวลา</th>
                </tr>
                </thead>
                <tbody>
                    {
                        
                        rows
                       
                    }
                 
                
                
                </tbody>
            </table>
                </div>


                    <div className="modal fade" id="save" tabIndex={-1} role="dialog" aria-labelledby="save" aria-hidden="true">
                    <div className="modal-dialog modal-md">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title custom_align" id="Heading"><i class="far fa-bell"></i> ตั้งค่าแจ้งเตือน</h4>
                                <button type="button" className="close" style={{ padding: 0, margin: 0 }} data-dismiss="modal" aria-hidden="true"><span className="fa fa-times" aria-hidden="true" /></button>
                            </div>
                            <div className="modal-body">
                                <div className="checkbox" >
                                    <label >
                                        <input type="checkbox"  id="chkAll"  onChange={this.handleChkAll.bind(this)}/>
                                        {/* checked={!!this.state.isShowLayer2} */}
                                        <span className="cr"><i className="cr-icon fa fa-check"></i>
                                       
                                        </span>
                                        เลือกทั้งหมด
                                    </label>
                                </div>
                                <hr/>
                                <div className="row">
                                    <div className="col-6 col-md-4">
                                        <div className="checkbox" >
                                            <label >
                                                <input type="checkbox"   id="alertS1"/>
                                                <span className="cr"><i className="cr-icon fa fa-check"></i>                                       
                                                </span>
                                                เครื่องยนต์ติด
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <div className="checkbox" >
                                            <label >
                                                <input type="checkbox"   id="alertS2" />
                                                <span className="cr"><i className="cr-icon fa fa-check"></i>                                      
                                                </span>
                                                เครื่องยนต์ดับ
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <div className="checkbox" >
                                            <label >
                                                <input type="checkbox"   id="alertO2" />
                                                <span className="cr"><i className="cr-icon fa fa-check"></i>                                      
                                                </span>
                                                ความเร็วเกิน
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <div className="checkbox" >
                                            <label >
                                                <input type="checkbox"   id="alertS3" />
                                                <span className="cr"><i className="cr-icon fa fa-check"></i>
                                                </span>
                                                ดัมป์เปิด
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <div className="checkbox" >
                                            <label >
                                                <input type="checkbox"   id="alertS4" />
                                                <span className="cr"><i className="cr-icon fa fa-check"></i>
                                                </span>
                                                ดัมป์ดับ
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <div className="checkbox" >
                                            <label >
                                                <input type="checkbox"   id="alertO1" />
                                                <span className="cr"><i className="cr-icon fa fa-check"></i>
                                                </span>
                                                แจ้งเตือนเลื่อนรถ
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <div className="checkbox" >
                                            <label >
                                                <input type="checkbox"   id="alertE2" />
                                                <span className="cr"><i className="cr-icon fa fa-check"></i>
                                                </span>
                                                แบตเตอรี่อ่อน
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <div className="checkbox" >
                                            <label >
                                                <input type="checkbox"   id="alertE3" />
                                                <span className="cr"><i className="cr-icon fa fa-check"></i>
                                                </span>
                                                แบตเตอรี่รถอ่อน
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <div className="checkbox" >
                                            <label >
                                                <input type="checkbox"   id="alertE4" />
                                                <span className="cr"><i className="cr-icon fa fa-check"></i>
                                                </span>
                                                ไม่ได้ไฟจากรถ
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <div className="checkbox" >
                                            <label >
                                                <input type="checkbox"    id="alertE6"/>
                                                <span className="cr"><i className="cr-icon fa fa-check"></i>
                                                </span>
                                                ไม่มีสัญญาณGPS
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <div className="checkbox" >
                                            <label >
                                                <input type="checkbox"   id="alertE7" />
                                                <span className="cr"><i className="cr-icon fa fa-check"></i>
                                                </span>
                                                รับสัญญาณGPS
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <div className="checkbox" >
                                            <label >
                                                <input type="checkbox"   id="alertE5" />
                                                <span className="cr"><i className="cr-icon fa fa-check"></i>
                                                </span>
                                                สายGPSถูกตัด
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <div className="checkbox" >
                                            <label >
                                                <input type="checkbox"   id="alertE1" />
                                                <span className="cr"><i className="cr-icon fa fa-check"></i>
                                                </span>
                                                รูดบัตร
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <div className="checkbox" >
                                            <label >
                                                <input type="checkbox"   id="alertO3" />
                                                <span className="cr"><i className="cr-icon fa fa-check"></i>
                                                </span>
                                                เข้า POI
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-4">
                                        <div className="checkbox" >
                                            <label >
                                                <input type="checkbox"   id="alertO4" />
                                                <span className="cr"><i className="cr-icon fa fa-check"></i>
                                                </span>
                                                ออกจาก POI
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer ">
                                <button  onClick={this.handleSave.bind(this)} type="button" className="btn btn-primary btn-lg"  data-dismiss="modal" aria-hidden="true" style={{ width: '100%' }} >
                                <span className="fa fa-check" />&nbsp;บันทึก</button>
                            </div>
                        </div>
                        {/* /.modal-content */}
                    </div>
                </div>

            </div>
        )
    }
}


export default CarAlertList;


// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/CarAlert/CarAlertList.js